import Stack from "@mui/material/Stack";
import AutoSizer, { Size } from "react-virtualized-auto-sizer";

import PageTitle from "../../widgets/PageTitle";
import SectionPaper from "../../widgets/SectionPaper";
import FactorMatrixView from "./FactorMatrixView";

const PricingTrends = () => (
  <AutoSizer>
    {(size: Size) => (
      <Stack direction="column" sx={{ width: size.width }}>
        <PageTitle />
        <SectionPaper>
          <FactorMatrixView />
        </SectionPaper>
      </Stack>
    )}
  </AutoSizer>
);

export default PricingTrends;
